// extracted by mini-css-extract-plugin
export default {"Emoji":"bce_a big_i big_q big_j"};